(() => {
  const STORAGE_KEY = 'poster-store:recent-products:v1';
  const MAX_STORED_PRODUCTS = 12;

  const readProducts = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(value)) throw new TypeError('Recently viewed data is not an array.');
      return value.filter((item) => item && typeof item.handle === 'string' && typeof item.url === 'string');
    } catch (error) {
      console.warn('Recently viewed products could not be read.', error);
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (removeError) {
        console.warn('Invalid recently viewed data could not be cleared.', removeError);
      }
      return [];
    }
  };

  const writeProducts = (products) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products.slice(0, MAX_STORED_PRODUCTS)));
    } catch (error) {
      console.warn('Recently viewed products could not be saved.', error);
    }
  };

  const createCard = (item) => {
    const link = document.createElement('a');
    link.className = 'ps-pdp-recent__card';
    link.href = item.url;

    const media = document.createElement('span');
    media.className = 'ps-pdp-recent__media';

    if (typeof item.image === 'string' && item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = typeof item.imageAlt === 'string' ? item.imageAlt : item.title || '';
      image.loading = 'lazy';
      image.width = 180;
      image.height = 180;
      media.append(image);
    }

    const title = document.createElement('strong');
    title.textContent = typeof item.title === 'string' ? item.title : item.handle;
    link.append(media, title);
    return link;
  };

  const initializeSection = (root) => {
    if (root.dataset.recentProductsInitialized === 'true') return;
    root.dataset.recentProductsInitialized = 'true';

    const dataElement = root.querySelector('[data-current-product]');
    const list = root.querySelector('[data-recent-products-list]');
    if (!dataElement || !list) return;

    let currentProduct;
    try {
      currentProduct = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.warn('Current product data could not be read for recently viewed products.', error);
      return;
    }

    const storedProducts = readProducts();
    const visibleProducts = storedProducts.filter((item) => item.handle !== currentProduct.handle);
    const limit = Math.max(1, Number(root.dataset.productsLimit) || 4);

    visibleProducts.slice(0, limit).forEach((item) => list.append(createCard(item)));
    if (list.childElementCount > 0) root.hidden = false;

    const updatedProducts = [
      currentProduct,
      ...storedProducts.filter((item) => item.handle !== currentProduct.handle)
    ];
    writeProducts(updatedProducts);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-recent-products]').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
